import { HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeFrExtra from '@angular/common/locales/extra/pt';
import localePT from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { StoreModule } from '@ngrx/store';
// módulo do componente Datatable
import { BlockUIModule } from 'ng-block-ui';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/primeng';
import 'rxjs/add/operator/toPromise';
import { AppComponent } from './app.component';
import { CardsMenuService } from './area-restrita/card-menu/service/cards-menu.service';
import { RecuperarSenhaGuard } from './area-restrita/guards/recuperarSenha.guard';
import { VerificarFormRouterGuard } from './area-restrita/guards/verificar-form-router.guard';
import { HomeModule } from './area-restrita/home/home.module';
import { HomeService } from './area-restrita/home/service/home.service';
import { AuthInterceptor } from './area-restrita/interceptor/auth.interceptor';
import { LoginService } from './area-restrita/login/service/login.service';
import { RecuperarSenhaModule } from './area-restrita/recuperar-senha/recuperar-senha.module';
import { AppRoutingModule } from './area-restrita/routes/app.routing.module';
import { AuthGuard } from './area-restrita/routes/guards/auth.guard';
import { AreaRestritaSharedModule } from './area-restrita/shared/area-restitra.shared.module';
import { ErrorsModule } from './area-restrita/shared/error/error.module';
import { gereciamentoPermissoesReducer } from './area-restrita/shared/reducers/gerenciamento-permissoes.reducer';
import { itemMenuReducer } from './area-restrita/shared/reducers/item-menu.reducer';
import { mesAnoReducer } from './area-restrita/shared/reducers/mes-ano.reducer';
import { operacacoItemMenuSistemaReducer } from './area-restrita/shared/reducers/operacaco-item-menu-sistema.reducer';
import { paramReducer } from './area-restrita/shared/reducers/param.reducer';
import { sistemasListaReducer } from './area-restrita/shared/reducers/sistemas-lista-agrupados.reducer';
import { PessoaService } from './area-restrita/shared/services/pessoa.service';
import { from } from 'rxjs/observable/from';
import { RecaptchaModule } from 'ng-recaptcha';
// import { DatatableModule, SharedCentrusModule } from 'front-end-components';



registerLocaleData(localePT, 'pt', localeFrExtra);

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        ErrorsModule,
        AppRoutingModule,
        AreaRestritaSharedModule,
        HttpClientModule,
        ToastrModule.forRoot(),
        BlockUIModule.forRoot(),
        RecaptchaModule.forRoot(),
        RecuperarSenhaModule,
        StoreModule.forRoot({
            param: paramReducer,
            mesAno: mesAnoReducer,
            gereciamentoPermissoes: gereciamentoPermissoesReducer,
            itemMenuLista: itemMenuReducer,
            operacacoItemMenuSistema: operacacoItemMenuSistemaReducer,
            sistemasLista: sistemasListaReducer
        }),
        JwtModule.forRoot({
            config: {
                throwNoTokenError: true,
                skipWhenExpired: true,
            },
        }),
        PdfViewerModule,
        HomeModule
    ],
    declarations: [
        AppComponent
    ],
    providers: [
        ConfirmationService,
        LoginService,
        HomeService,
        PessoaService,
        AuthGuard,
        VerificarFormRouterGuard,
        RecuperarSenhaGuard,
        CardsMenuService,
        AuthInterceptor,
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        { provide: LOCALE_ID, useValue: 'pt' },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/app.module.ts